<template>
  <div v-if="modelValue && material" class="preview-overlay" @click.self="close">
    <div class="preview-modal" role="dialog" aria-modal="true" aria-labelledby="matPreviewTitle">
      <div class="preview-head">
        <div>
          <h3 id="matPreviewTitle">{{ material.name }}</h3>
          <p>{{ subtitle }}</p>
        </div>
        <button type="button" class="preview-close" aria-label="关闭" @click="close">×</button>
      </div>
      <div class="preview-body">
        <img
          v-if="imageSrc"
          :src="imageSrc"
          :alt="material.name"
          class="preview-img"
        />
        <div v-else class="preview-fallback">该素材预览丢失，请重新上传</div>
      </div>
      <div class="preview-foot">
        <button type="button" class="btn" @click="close">关闭</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  material: {
    type: Object,
    default: null,
  },
  imageSrc: {
    type: String,
    default: '',
  },
  catLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'close']);

const subtitle = computed(() => {
  if (!props.material) return '';
  const parts = [];
  if (props.catLabel) parts.push(props.catLabel);
  if (props.material.uploadedAt) parts.push(props.material.uploadedAt);
  return parts.join(' · ');
});

function close() {
  emit('update:modelValue', false);
  emit('close');
}
</script>

<style scoped>
.preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.preview-modal {
  width: min(640px, 100%);
  max-height: min(84vh, 700px);
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.preview-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px 14px;
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

.preview-head h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--text-dark, #0f172a);
}

.preview-head p {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--text-muted, #64748b);
}

.preview-close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
  display: grid;
  place-items: center;
  transition: background 0.15s ease;
}

.preview-close:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.preview-body {
  min-height: 220px;
  max-height: min(58vh, 500px);
  padding: 20px;
  background: #f8fafc;
  background-image: radial-gradient(#e2e8f0 1.2px, transparent 1.2px);
  background-size: 12px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.preview-img {
  max-width: 100%;
  max-height: min(52vh, 460px);
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
}

.preview-fallback {
  padding: 48px 24px;
  text-align: center;
  color: var(--text-muted, #64748b);
  font-size: 14px;
}

.preview-foot {
  display: flex;
  justify-content: flex-end;
  padding: 14px 22px;
  border-top: 1px solid var(--border-color, #e2e8f0);
  background: #f8fafc;
}

.btn {
  padding: 8px 18px;
  border: 1px solid var(--border-color, #cbd5e1);
  border-radius: 8px;
  background: #ffffff;
  color: var(--text-dark, #0f172a);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.btn:hover {
  background: #f1f5f9;
}
</style>
